module.exports = __webpack_public_path__ + "img/big-logo.5ff13d72.svg";